const liveSearch = (search) => {
    return (items) => {
        if (!search) {
            return items
        }

        if (items === null) {
            return null
        }
        if (Array.isArray(items)) {
            return items.filter(item => liveSearch(search)(item))
        }

        if (typeof items !== 'object') {
            return false
        }

        const values = getValueString(items).toLowerCase();

        const searchStrs = search.toLowerCase().split(/\W/).map(s => s.replace(/^0/, ''));

        const matches = searchStrs.reduce((count, searchStr) => {
            return count + (values.includes(searchStr) ? 1 : 0)
        }, 0);

        return matches > 0;
    }
}

const getValueString = (obj, str = '') => {
    if (obj === null || obj === undefined) {
        return str;

    } else if (typeof obj === 'object') {
        return Object.values(obj).reduce((str, v) => getValueString(v, str), str);

    } else if (Array.isArray(obj)) {
        return obj.reduce((str, v) => {
            return getValueString(v, str);
        }, str);

    } else if (typeof obj === 'string') {
        return str + ' ' + obj;

    } else {
        return str;
    }
}

export {
    liveSearch,
}
